import { CLICK_ON_DOM, COLLECT_BEAT, DROP_BEAT } from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').Coord} Coord
 */

/**
 * @typedef {ReturnType<typeof clickOnDom> | ReturnType<typeof dropBeat> | ReturnType<typeof collectBeat>} DomEventsActions
 */

/**
 * @param {number} x
 * @param {number} y
 * @return {{ type: 'CLICK_ON_DOM', x: number, y: number }}
 */
export const clickOnDom = (x, y) => {
  return {
    type: CLICK_ON_DOM,
    x,
    y,
  }
}

/**
 * @param {number} beatId
 * @param {Coord} coord
 * @return {{ type: 'DROP_BEAT', id: number, coord: Coord }}
 */
export function dropBeat(beatId, coord) {
  return { type: DROP_BEAT, id: beatId, coord }
}

/**
 * @return {{ type: 'COLLECT_BEAT' }}
 */
export function collectBeat() {
  return { type: COLLECT_BEAT }
}
